import React from "react";
import {
    Button,
    Table
} from "reactstrap";

const showUserName = (users, userId) => {
    const user = users.filter((u) => u.id === userId);
    let element;
    if (typeof user[0] !== 'undefined') {
        element = user[0];
    } else {
        element = {
            first_name: " ",
            last_name: " "
        }
    }
    return `${element.first_name} ${element.last_name}`
};


const RoleTable = ({ roles, onEdit, onDelete, users }) => (
    <Table>
        <thead>
            <tr>
                <th>Title</th>
                <th>Status</th>
                <th>Overview</th>
                <th>Created By</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            {roles.map((role) => (
                <tr key={role.id}>
                    <td>{role.title}</td>
                    <td>{role.status === 1 ? 'Actif' : 'Inactif'}</td>
                    <td>{role.overview}</td>
                    <td>{showUserName(users, role.created_by)}</td>
                    <td>
                        <Button color="primary" onClick={() => onEdit(role)}>
                            Edit
                        </Button>{" "}
                        <Button color="danger" onClick={() => onDelete(role)}>
                            Delete
                        </Button>
                    </td>
                </tr>
            ))}
        </tbody>
    </Table>
);

export default RoleTable;